import { usePlayer } from "../../state/PlayerContext";
import { t } from "../../strings";
import { formatRcd } from "../format";

/** §7.6 `fees`: current values come from Config via /players/me. */
export function FeesPanel() {
  const { me } = usePlayer();
  if (!me) return null;
  return (
    <section className="panel" aria-labelledby="fees-h">
      <h3 id="fees-h">Fees</h3>
      <p>{t.fees(me.fees.perSave, me.fees.perAutosave, me.fees.perMint)}</p>
      <p className="hint">Wallet actions paid in ₽ cost {formatRcd(me.fees.perRelayedTx)} each, from your in-game balance.</p>
      {BigInt(me.feeDebtRcd) > 0n && <p className="banner warn">{t.feeDebt(me.feeDebtRcd)}</p>}
    </section>
  );
}
